module.exports = __webpack_public_path__ + "materialdesignicons-webfont.f89ba2d89e5710c9ff4d.svg";


//////////////////
// WEBPACK FOOTER
// D:/Agent Portal Revert commisions/agent-portal/node_modules/mdi/fonts/materialdesignicons-webfont.svg?v=2.0.46
// module id = ../../../../mdi/fonts/materialdesignicons-webfont.svg?v=2.0.46
// module chunks = styles